var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabDrafts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08398 30C2.25898 30 1.55298 29.7065 0.965984 29.1195C0.378984 28.5325 0.0849844 27.826 0.0839844 27V3C0.0839844 2.175 0.377984 1.469 0.965984 0.882C1.55398 0.295 2.25998 0.001 3.08398 0H13.8465C14.2465 0 14.628 0.0750001 14.991 0.225C15.354 0.375 15.6725 0.5875 15.9465 0.8625L23.2215 8.1375C23.4965 8.4125 23.709 8.7315 23.859 9.0945C24.009 9.4575 24.084 9.8385 24.084 10.2375V27C24.084 27.825 23.7905 28.5315 23.2035 29.1195C22.6165 29.7075 21.91 30.001 21.084 30H3.08398ZM13.584 9V3H3.08398V27H21.084V10.5H15.084C14.659 10.5 14.303 10.356 14.016 10.068C13.729 9.78 13.585 9.424 13.584 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabDrafts);
export default __webpack_public_path__ + "static/media/tabDrafts.f51dd84ed59a514b8c6b36093f52d2c4.svg";
export { ForwardRef as ReactComponent };